import CornerBadge from '../../CornerBadge';
import { EBadgePosition, EBadgeType } from 'utils/enums';
import MiddleBadge from '../../MiddleBadge';
import { EBadgeDesignType, SaleBadgeProps } from '../../types';
import { generateSalePercentageBasedOnType } from 'utils';

const badgeDesignDic = {
  [EBadgeDesignType.CORNER]: CornerBadge,
  [EBadgeDesignType.MIDDLE]: MiddleBadge,
};
export const DefaultSaleBadge = ({
  salePercentage,
  position = EBadgePosition.RIGHT,
  text,
  designType = EBadgeDesignType.CORNER,
  type = EBadgeType.RIBBON,
  salePercentageDisplayType,
  isTextAutoResized
}: SaleBadgeProps) => {
  const ribbonText =
    text ??
    generateSalePercentageBasedOnType(
      salePercentage,
      salePercentageDisplayType,
    );
  const BadgeDesign = badgeDesignDic[designType];
  return (
    <BadgeDesign
      salePercentage={salePercentage}
      type={type}
      position={position}
      emblem={{
        imageUrl: '',
      }}
      ribbon={{
        text: ribbonText,
        textColor: {
          colorOne: 'white',
        },
        backgroundColor: {
          colorOne: 'white',
        },
      }}
      isTextAutoResized={isTextAutoResized}
    />
  );
};
